import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import SteelBuildingEstimatesWrapper from "@components/layouts/steelbuildingestimatesWrapper";
import MainBanner from "@components/steelbuildingestimates/mainBanner";

const Advantages = dynamic(
    () => import("@components/steelbuildingestimates/advantages"),
);
const BuildingTypes = dynamic(
    () => import("@components/steelbuildingestimates/buildingTypes"),
);
const OffersList = dynamic(() => import("@components/shared/offersList"));

import { useDomainContext } from "@hooks/useDomainContext";

export default function SteelBuildingEstimatesHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <SteelBuildingEstimatesWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <Advantages />
            <BuildingTypes />
        </SteelBuildingEstimatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
